import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DeviceFrameset } from "react-device-frameset";
import "react-device-frameset/styles/marvel-devices.min.css";
import templateService from "../../../services/template.service";
import {toast} from 'react-toastify'

function ClinicEditSmsTemplate() {

  const {clinicId, templateId } = useParams();
  const [isEcx, setIsEcx] = useState(false);
  const [template, setTemplate] = useState(null);
  const [txtContent,setTxtContent] = useState(null);
  const [txtType,setTxtType] = useState(null)
  const [txtStatus,setTxtStatus] = useState(1)
  const navigate = useNavigate()
  
  useEffect(() => {
    //check if templateid contains ecx or cli in first 3 characters
  
    getClinicSMSTemplate(clinicId, templateId);
  }, []);

  
  const getClinicSMSTemplate = (clinicid, clitid) => {
    templateService
      .getSmsTemplateById(clinicid, clitid)
      .then((res) => {
        console.log(res.data);
        setTemplate(res.data);
        setTxtContent(res.data.content)
        setTxtType(res.data.type)
      })
      .catch((error) => {
        console.log("Error while getting Clinic SMs Tempalte");
      });
  };
  const handleTextAreaChange = (event)=>{
        setTxtContent(event.target.value)
  }
  const handleAdd = ()=>{
    //things needed
       //type , mediumType="SMS", subjectLine=null, content, usedBy,voiceSequence=null 
   const data = {
      "id" : templateId,
      "clinicId": clinicId,
       "type": txtType,
       "status": txtStatus,
     //  "subjectLine" : null,
       "content" : txtContent,
      // "voiceSequence" : null
   }
   templateService.updateSmsTemplate(clinicId,templateId,data)
   .then(res=>{
        toast.success("Template Saved.",{
           position:toast.POSITION.BOTTOM_RIGHT
        })
   })
   .catch(err=>{
     toast.error("Cannot Create New Template.",{
       position:toast.POSITION.BOTTOM_RIGHT
    })
    console.log(err)
   })
 }

 const handleCancel = ()=>{
   navigate('/sms-template');
 }

 const handletxtTypeChange = (event)=>{
   setTxtType(event.target.value)
 }
const handleSelectStatusChange = (event) =>{
  setTxtStatus(event.target.value)
}

  return (
    <>
      <div className="container container-xxl">
        <div className="row">
          <div className="col-6">
            <div className="d-flex justify-content-center">
              <DeviceFrameset device="iPhone X">
                <div
                  style={{
                    marginTop: "100px",
                    marginLeft: "30px",
                    padding: "15px",
                    display: "inline-block",
                    position: "relative",
                    width: "300px",
                    height: "auto",
                    backgroundColor: "lightyellow",
                    borderRadius: "30px",
                  }}
                >
               {txtContent}
                </div>
              </DeviceFrameset>
            </div>
          </div>
          <div className="col-6">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Sms Template</h4>
                <span className="card-subtitle">Type : {txtType}</span>

              <div className="form-group">
                  <label htmlFor="" className="form-label">Status:</label>
                  <select name="selectStatus" id="" onChange={handleSelectStatusChange} className="form-select">
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
              </div>
                <div className="form-group">
                  <label htmlFor="" className="form-label">
                    Content
                  </label>
                  <textarea
                    name=""
                    id=""
                    rows="5"
                    className="form-control"
                    value={txtContent}
                    maxLength={600}
                    onChange={handleTextAreaChange}
                  ></textarea>
                   <div className="form-text">Characters : {txtContent && txtContent.length} / 600</div>
                </div>
                <div className="d-flex justify-content-between mt-3">
                                      <button className="btn btn-primary btn-sm" onClick={handleAdd}><i className="bi bi-floppy2"></i> Save Template</button>
                                      <button className="btn btn-secondary btn-sm" onClick={handleCancel}><i className="bi bi-x-square"></i> Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClinicEditSmsTemplate;
